import React, { type FC } from 'react';
import { MainPageSideBar } from './SubComponents/MainPageSideBar/MainPageSideBar';
import { HeadingSection } from './SubComponents/PageHeader/HeadingSection';
import { TemplatesGrid } from '../CommonComponents/TemplatesGrid/TemplatesGrid';
import { useTemplatesData } from '../../hooks/useTemplatesData';
import { TemplatesGridHeading } from './SubComponents/TemplatesGridHeading';
import { usePageNavigate } from '../../hooks/usePageNavigate';
import { useTabs } from '../../hooks/useTabs';
import { AppLoader } from '../App/AppLoader';
import { DataHooks } from '../../constants/dataHooks';
import { filterToUrlParamMapper } from '../../utils/urlParams-utils';
import { useTemplatesPageBi } from '../../hooks/useTemplatesPageBi';
import { Box, Divider } from '@wix/design-system';

export const TemplatesMainPage: FC = () => {
  const { templates, templatesLoaded } = useTemplatesData();
  const { navigateToTemplate, getExternalTemplateUrl, shouldHideSidebar } =
    usePageNavigate();
  const { shouldDisplayTemplateByTab, activeTabId } = useTabs();
  const filteredTemplatesByTab = templates.filter(shouldDisplayTemplateByTab);
  const { reportClickOnTemplate } = useTemplatesPageBi();
  const mainGridRef = React.useRef<HTMLDivElement>(null);
  const originTab = filterToUrlParamMapper?.[activeTabId];

  if (!templatesLoaded) {
    return <AppLoader />;
  }

  return (
    <div data-hook={DataHooks.MainPage}>
      <HeadingSection />
      <Divider />
      <Box align={shouldHideSidebar ? 'center' : 'left'}>
        {!shouldHideSidebar && (
          <>
            <MainPageSideBar mainGridRef={mainGridRef} />
            <Divider direction="vertical" />
          </>
        )}
        <Box
          dataHook={DataHooks.MainPageGridLayout}
          gap="40px"
          width="100%"
          align="center"
          minHeight="600px"
          direction="vertical"
          padding="40px 48px 48px"
          ref={mainGridRef}
          maxWidth={shouldHideSidebar ? '1284px' : ''}
        >
          <TemplatesGridHeading />
          <TemplatesGrid
            templates={filteredTemplatesByTab}
            onTemplateClick={(template) => {
              reportClickOnTemplate(
                template.id,
                getExternalTemplateUrl(template),
              );
              navigateToTemplate(template, originTab);
            }}
          />
        </Box>
      </Box>
    </div>
  );
};
